/**
 * Agent portal — split-bundle entry App.
 */
import { Routes, Route, Navigate } from "react-router-dom";
import { PortalAppShell } from "@/shared/app/PortalAppShell";
import SafeRoute from "@/components/system/SafeRoute";
import { ProtectedAgentRoute, AgentLayout } from "@/apps/agent";
import { AgentLogin, AgentCasesWorkspace, AgentSubmitLeads, AgentMySubmissions, AgentCreateQuote, AgentMyQuotes } from "@/apps/agent/routes";
import { portalPath } from "@/shared/app/portalPath";
import { CurrencyProvider } from "@/shared/contexts/CurrencyContext";

const S = ({ name, children }: { name: string; children: React.ReactNode }) => (
  <SafeRoute name={name}>{children}</SafeRoute>
);

const AgentApp = () => {
  const p = portalPath("agent");
  const layout = <ProtectedAgentRoute><AgentLayout /></ProtectedAgentRoute>;
  const children = (
    <>
      <Route path="cases" element={<S name="AgentCases"><AgentCasesWorkspace /></S>} />
      <Route path="submit-leads" element={<S name="AgentSubmitLeads"><AgentSubmitLeads /></S>} />
      <Route path="my-submissions" element={<S name="AgentMySubmissions"><AgentMySubmissions /></S>} />
      <Route path="create-quote" element={<S name="AgentCreateQuote"><AgentCreateQuote /></S>} />
      <Route path="my-quotes" element={<S name="AgentMyQuotes"><AgentMyQuotes /></S>} />
      <Route path="dashboard" element={<Navigate to={p("/cases")} replace />} />
      <Route path="leads" element={<Navigate to={p("/cases")} replace />} />
      <Route path="notifications" element={<Navigate to={p("/cases")} replace />} />
      <Route path="profile" element={<Navigate to={p("/cases")} replace />} />
      <Route path="cases/:id" element={<Navigate to={p("/cases")} replace />} />
    </>
  );
  return (
    <CurrencyProvider>
    <PortalAppShell portal="agent">
      <Routes>
        {/* Canonical (subdomain) */}
        <Route path="/login" element={<S name="AgentLogin"><AgentLogin /></S>} />
        <Route element={layout}>
          <Route path="/" element={<Navigate to={p("/cases")} replace />} />
          <Route path="/cases" element={<S name="AgentCases"><AgentCasesWorkspace /></S>} />
          <Route path="/submit-leads" element={<S name="AgentSubmitLeads"><AgentSubmitLeads /></S>} />
          <Route path="/my-submissions" element={<S name="AgentMySubmissions"><AgentMySubmissions /></S>} />
          <Route path="/create-quote" element={<S name="AgentCreateQuote"><AgentCreateQuote /></S>} />
          <Route path="/my-quotes" element={<S name="AgentMyQuotes"><AgentMyQuotes /></S>} />
          <Route path="/dashboard" element={<Navigate to={p("/cases")} replace />} />
          <Route path="/leads" element={<Navigate to={p("/cases")} replace />} />
          <Route path="/notifications" element={<Navigate to={p("/cases")} replace />} />
          <Route path="/profile" element={<Navigate to={p("/cases")} replace />} />
          <Route path="/cases/:id" element={<Navigate to={p("/cases")} replace />} />
        </Route>
        {/* Prefixed alias (Lovable preview) */}
        <Route path="/agent/login" element={<S name="AgentLogin"><AgentLogin /></S>} />
        <Route path="/agent" element={layout}>{children}</Route>
        <Route path="*" element={<Navigate to={p("/login")} replace />} />
      </Routes>
    </PortalAppShell>
    </CurrencyProvider>
  );
};

export default AgentApp;
